import 'whatwg-fetch';
import qs from 'qs';
import logger from './logger';
import { getErrorMessage } from './error-handler';

function parseJSON(response) {
  return new Promise((resolve, reject) => response.json()
    .then((json) => resolve({
      status: response.status,
      message: getErrorMessage(json),
      errors: json.errors,
      response: json,
    }))
    .catch(() => reject({
      status: response.status,
      message: response.statusText,
    })));
}

/**
  * @deprecated Use utils/custom-request.ts instead
  */
export default function request(
  url,
  params = null,
  method = 'GET',
  headers = {},
  options = {}
) {

  options = { ...options, method };
  let requestUrl = url;

  if (params) {
    if (method === 'GET') {
      const queryString = qs.stringify(params, {
        encodeValuesOnly: true,
        skipNulls: true,
      });
      requestUrl = `${url}?${queryString}`;
    } else {
      options.body = JSON.stringify(params);
    }
  }

  return new Promise((resolve, reject) => {
    fetch(requestUrl, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...headers,
      },
    })
      .then(response => {
        if (response.status >= 200 && response.status < 300) {
          const type = response.headers.get('Content-type');
          if ((type && type.indexOf('application/json') === -1) || response.status === 204) {
            return resolve(response);
          }
          return resolve(response.json());
        } else {

          return parseJSON(response)
            .then(response => {
              logger.log(`API error request: ${response.message} `, requestUrl, response);
              return reject(response);
            })
            .catch(response => {
              logger.warn('API error request ', requestUrl, response);
              return reject(response);
            });
        }
      })
      .catch(err => {
        logger.warn('Failed to fetch ', requestUrl, err);
        return reject(err);
      });
  });
}

/**
 * @deprecated use qs.stringify instead
 */
export function createQueryParams(params) {
  return Object.keys(params)
    .filter((k) => typeof params[k] !== 'undefined')
    .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
    .join('&');
}
